// Firebase config
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Firebase config - always use production
const firebaseConfig = {
  apiKey: 'AIzaSyADYffSRhM4HTOHDtvN3jKYmDLc898-E30',
  authDomain: 'cocorev-43d9e.firebaseapp.com',
  projectId: 'cocorev-43d9e',
  storageBucket: 'cocorev-43d9e.firebasestorage.app',
  messagingSenderId: '875287237664',
  appId: '1:875287237664:web:e904302cc3604e38021845',
  measurementId: 'G-6MQH7D00HB',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Initialize Analytics only in browser environment
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
